import { Component, OnInit } from '@angular/core';
import { AlertService } from 'ngx-alerts';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})

export class ContactUsComponent implements OnInit {

  name: string = ''
  email: any
  phone: string = ''
  title: any
  message: any
  disabled_: boolean = false

  load:boolean=false
  WorkingHours: string = ''
  Permanence: string = ''
  contactUs: string = ''
  home: string = ''
  location: string = ''
  titleCompany: string = ''
  EnterMessage: string = ''

  name_: string = ''
  email_: string = ''
  phone_: string = ''
  title_: string = ''
  message_: string = ''
  sendMessage: string = ''
  NameMessage: string = ''
  PhoneMessage: string = ''
  EmailMessage: string = ''
  TitleMessage: string = ''
  messageMessage: string = ''
  success: string = ''
  error: string = ''

  address_: string = ''
  email__: string = ''
  ph1: string = ''
  ph2: string = ''

  constructor(private home_service: HomeService,private alertService: AlertService) { }


  Validation(): boolean {

    // if (this.name == '' || this.name == null) {
    //   this.alertService.warning(this.NameMessage);

    //   return false;
    // }

     if (this.title == '' || this.title == null) {
      this.alertService.warning(this.TitleMessage);

      return false;
    }

     else if (this.email == '' || this.email == null) {
      this.alertService.warning(this.EmailMessage);

      return false;
    }
    // else if (this.phone == '' || this.phone == null) {
    //   this.alertService.warning(this.PhoneMessage);

    //   return false;
    // }

    else if (this.message == '' || this.message == null) {
      this.alertService.warning(this.messageMessage);

      return false;
    }
    return true;
  }


  clear() {
    this.title = ''
    this.name = ''
    this.phone = ''
    this.title = ''
    this.message = ''
    this.email = ''
  }

  send(): void {

    if (this.Validation()) {
      this.load = false
      this.disabled_ = true

      this.home_service.sendMessage('i', 'En', this.name, this.email, this.phone, this.title, this.message, 'c-1', '0', '1').subscribe(data => {

        let arr = data as any[]

        if (arr[0]["column2"] == 'success') {
          this.alertService.success(this.success);
          this.disabled_ = false
          this.clear()
        }
        else {
          this.alertService.danger(this.error);
          this.disabled_ = false
        }
        this.load = true
      });

      this.disabled_ = false
    }


  }

  ngOnInit(): void {

   // this.load = false

    // this.home_service.getLangJson('En').subscribe(data => {
    //   this.home = data[0]['HeaderAndFooter']['Home']
    //   this.contactUs = data[0]['HeaderAndFooter']['contactUs']
    //   this.WorkingHours = data[0]['contactUs']['WorkingHours']
    //   this.Permanence = data[0]['contactUs']['Permanence']
    //   this.location = data[0]['HeaderAndFooter']['location']
    //   this.titleCompany = data[0]['Home']['titleCompany']
    //   this.EnterMessage = data[0]['contactUs']['EnterMessage']
    //   this.name_ = data[0]['contactUs']['name']
    //   this.email_ = data[0]['contactUs']['email']
    //   this.phone_ = data[0]['contactUs']['phone']
    //   this.title_ = data[0]['contactUs']['title']
    //   this.message_ = data[0]['contactUs']['message']
    //   this.sendMessage = data[0]['contactUs']['sendMessage']
    //   this.NameMessage = data[0]['contactUs']['NameMessage']
    //   this.PhoneMessage = data[0]['contactUs']['PhoneMessage']
    //   this.EmailMessage = data[0]['contactUs']['EmailMessage']
    //   this.TitleMessage = data[0]['contactUs']['TitleMessage']
    //   this.messageMessage = data[0]['contactUs']['messageMessage']
    //   this.success = data[0]['contactUs']['success']
    //   this.error = data[0]['contactUs']['error']

    //   this.home_service.getBrn('s','c-1','En').subscribe(data=>{
    //     let arr = data as any[]
    //     this.address_ = arr[0]['brnAddress']
    //     this.email__ = arr[0]['brnEmail']
    //     this.ph1 = arr[0]['brnPho1']
    //     this.ph2 = arr[0]['brnpho2']

    //     this.load = true
    //   })

    // })




  }

}
